export default {
  // 获取手机验证码
  getAuthCodeByVerifyCode: '/member/anonymous/amc/getAuthCodeByVerifyCode',
  // 获取用户信息
  getMemberByToken: '/member/anonymous/amc/getMemberByToken',
  // 微信授权登录后获取登录信息
  getWeixinMemberInfo: '/member/anonymous/amc/getWeixinMemberInfo',
  // 检测手机号是否可用
  mobilePhoneExistForH5: '/member/anonymous/amc/mobilePhoneExistForH5',
  // 绑定手机号
  boundMobilephone: '/member/anonymous/amc/boundMobilephone',
  // 获取图形验证码
  getLoginVerifyCode: '/member/anonymous/amc/getLoginVerifyCode',
}